// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"RW-z","inlineTitle":"SW-z","sponsoredAdsWrapper":"TW-z","marketplaceRecosWrapper":"UW-z"};